import React, { useRef } from 'react';

import ModalPhotoBase from './ModalPhotoBase';

import PhotoBg from '../../../../../Images/modals/photographers/yvone/bg_yvone.png';
import Photo1 from '../../../../../Images/modals/photographers/yvone/photo-1.png';
import Photo2 from '../../../../../Images/modals/photographers/yvone/photo-2.png';

import {
  Photo_Yvone,
  Text_Yvone,
  TextPhoto1_Yvone,
  TextPhoto2_Yvone,
} from '../../../../../utils/ES/Modals/photographers';

const ModalYvone = () => {
  return (
    <>
      <ModalPhotoBase
        id="photo-yvone"
        mainBg={PhotoBg}
        directorName={Photo_Yvone}
        mainVideoBg={Photo1}
        videoText1={TextPhoto1_Yvone}
        directorText={Text_Yvone}
        rowImage1={Photo2}
        videoText2={TextPhoto2_Yvone}
        rowWidth1={'728px'}
        rowWidth2={'0px'}
        rowWidth3={'0px'}
        mainGallery={'yvone-gallery-1'}
        gallery2={'yvone-gallery-2'}
      />
    </>
  );
};

export default ModalYvone;
